// Une nombres de clase ignorando los valores vacíos (sin dependencias externas).
export function cn(...classes: Array<string | false | null | undefined>): string {
  return classes.filter(Boolean).join(' ');
}
